import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { key, palette } from 'styled-theme';

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 120px;
`;

export const Wrapper = styled.div`
  display: grid;
  gap: ${key('sizes.gap.normal')};
`;

export const SectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const SubHeading = styled(Label).attrs({ size: 'normal', color: 'black' })``;

export const SubLabel = styled(Label).attrs({ size: 'small', color: 'black' })`
  font-size: 16.7px;
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
`;

export const SuggestionItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;
export const ErrorMessage = styled.p`
  color: #a05c4b;
  font-size: 14px;
`;

export const PhoneInputContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  gap: 8px;
  grid-template-columns: 1fr 4fr;
`;

export const CountryCodeSelect = styled.select`
  font-size: 14px;
  padding: 10px;
  border: 1px solid ${palette('border', 0)};
  border-radius: 4px;
  background-color: #fff;
  color: #606266;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 110px;
  width: 100%;
  height: 100%;

  &:focus {
    border-color: #409eff;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 55%;
  right: 10px;
  transform: translateY(-55%);
  pointer-events: none;
`;
